import { render, staticRenderFns } from "./AppBackIndex.vue?vue&type=template&id=070f16c7&scoped=true"
import script from "./AppBackIndex.vue?vue&type=script&lang=js"
export * from "./AppBackIndex.vue?vue&type=script&lang=js"
import style0 from "./AppBackIndex.vue?vue&type=style&index=0&id=070f16c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f16c7",
  null
  
)

export default component.exports